import { actions, fetchUser } from "./userSlice";

export default {
  ...actions,
  fetchUser,
};
